import { useCategoryPageSplitFilterQuery } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/useCategoryPageSplitFilterQuery/useCategoryPageSplitFilterQuery";
import { useCategoryPageQuery } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/useCategoryPageQuery";
import { useIsCategoryPageFilterSplitEnabled } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageFilterSplitEnabled";

export const useCategoryPageFormattedTotalResults = (): string | undefined => {
  const isCategoryPageFilterSplitEnabled =
    useIsCategoryPageFilterSplitEnabled();
  const splitFilterFormattedTotalResults =
    useCategoryPageSplitFilterQuery().data?.formatted_total_products_count;
  const formattedTotalResults =
    useCategoryPageQuery().data?.formatted_total_primary_results_count;

  if (isCategoryPageFilterSplitEnabled) {
    return splitFilterFormattedTotalResults;
  }
  return formattedTotalResults;
};
